import FxstockWalletPageContainer from "../../Component/WalletTransfer/FxstockWallet/FxstockWallet"

const FxstockWalletPage = () => {
  return (
    <div className='page-body'>
      <FxstockWalletPageContainer />
    </div>
  )
}

export default FxstockWalletPage